import gallery from "./components/gallery";
import loadmore from "./components/loadmore";
import newsletterrotate from "./components/newsletter-rotate";
import photoswipe from "./components/photoswipe";
import popular from "./components/popular";
import popup from "./components/popup";
import readingprogress from "./components/readingprogress";
import smartlist from "./components/smartlist";
import tabs from "./components/tabs";

console.log("Started JS App Singular");

gallery();
loadmore();
newsletterrotate();
photoswipe();
popular();
popup();
readingprogress();
smartlist();
tabs();
